import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { BRAND } from "@/lib/brand";

const LABELS = { ca: "Qui som", es: "Quiénes somos", en: "Who we are" };

export default function AboutVideo() {
  const { locale, t } = useI18n();
  const label = LABELS[locale] || LABELS.ca;
  return (
    <section
      id="qui-som"
      data-testid="about-video-section"
      className="relative py-16 md:py-20 px-6 md:px-12 lg:px-24 bg-[#fdfcf9]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        {/* Text left */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="order-2 lg:order-1"
        >
          <p
            className="uppercase tracking-[0.32em] text-xs text-[#3e664c] font-medium mb-4"
            data-testid="about-video-eyebrow"
          >
            Aura
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] uppercase leading-[1.05]">
            {label}
          </h2>
          <p
            className="mt-6 text-[#5C544F] text-base md:text-lg leading-relaxed max-w-xl"
            data-testid="about-video-desc"
          >
            {t.hero.desc}
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#disponibilidad"
              data-testid="about-cta-calendar"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#3e664c] hover:bg-[#2e5949] text-[#fdfcf9] text-xs uppercase tracking-[0.18em] font-medium transition-colors"
            >
              {t.hero.ctaCalendar}
              <span>→</span>
            </a>
            <a
              href="#eventos"
              data-testid="about-cta-events"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#3e664c]/30 hover:border-[#3e664c] text-[#3e664c] text-xs uppercase tracking-[0.18em] font-medium transition-colors"
            >
              {t.hero.ctaEvents}
            </a>
          </div>
        </motion.div>

        {/* Video right */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="order-1 lg:order-2 rounded-3xl overflow-hidden shadow-[0_30px_60px_rgb(28,36,33,0.18)] bg-[#1c2421] max-w-xl w-full mx-auto lg:mx-0 lg:ml-auto"
        >
          <video
            src={BRAND.introVideoUrl}
            autoPlay
            loop
            muted
            playsInline
            controls
            preload="metadata"
            className="w-full h-auto block"
            data-testid="about-video"
          />
        </motion.div>
      </div>
    </section>
  );
}
